import '../../style/index.less';
import './index.less'; // style dependencies

import '../../tabs/style';
import '../../row/style';
import '../../col/style';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/card/style/index.js
// module id = 1071
// module chunks = 0